import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerHelper } from '../../../../shared/validators/date-picker-form-validators';
import { Document } from '@models/documents/document';
import { CompanySubtype, CompanyType } from '@models/companies/company-enums';
import { SelectOption } from '@models/ui-models/select-options';
import { DatePickerComponent } from '@shared/controls/date-picker/date-picker.component';
import { SelectComponent } from '@shared/controls/select/select.component';
import {
  CompanyChangeType,
  ChangeCompanyTypeStepsEnum,
  companySubtypeDictionaryOptions,
  companyTypeOptions
} from '../../../models/company/company-change-type.model';
import { BaseStepperFormComponent, StepperFormComponent, StepperFormDescriptionComponent } from "../../stepper-form";


// Application for change of company type
@Component({
  selector: 'app-form206',
  standalone: true,
  imports: [
    StepperFormComponent,
    StepperFormDescriptionComponent,
    ReactiveFormsModule,
    SelectComponent,
    DatePickerComponent
  ],
  templateUrl: './company-change-type.component.html',
  styleUrl: '../../stepper-form/base-stepper-component/base-stepper-form.component.scss',
})
export class CompanyChangeTypeComponent extends BaseStepperFormComponent<ChangeCompanyTypeStepsEnum, CompanyChangeType> implements OnInit {
  readonly companyTypeOptions = companyTypeOptions;
  override readonly StepsEnum = ChangeCompanyTypeStepsEnum;

  minDate!: NgbDateStruct;
  maxDate!: NgbDateStruct;

  form = new FormGroup({
    changeDate: new FormControl<Date | null>(null),
    companyType: new FormControl<CompanyType | null>(null, Validators.required),
    companySubtype: new FormControl<CompanySubtype | null>(null, Validators.required),
  });

  override stepperForm = new FormGroup({
    [ChangeCompanyTypeStepsEnum.FormDescription]: new FormGroup({}),
    [ChangeCompanyTypeStepsEnum.ChangeOfType]: this.form,
  });

  constructor() {
    super();
    this.setupSteps(ChangeCompanyTypeStepsEnum);
    this.redirectAfterSubmit = true;
  }

  ngOnInit(): void {
    this.minDate = DatepickerHelper.getDateOfEstablishmentMinDate(this.companyChangeData.dateOfEstablishment);
    this.maxDate = DatepickerHelper.getNextNYearsStruct(10);

    this.form.controls.changeDate.setValue(DatepickerHelper.getToday());
    this.setupChange();
  }

  override setupChange(): void {
    if (!this.isEdit) {
      return;
    }

    this.form.patchValue(this.formModel);
  }

  override buildDocument(): Document | null {
    const change = new CompanyChangeType({
      ...this.form.value as Partial<CompanyChangeType>,
    });

    try {
      return new Document({
        changes: [change],
        entityId: this.companyChangeData?.entityId,
        type: 'c:206',
        documentId: this.companyChangeData?.documentId,
      });
    } catch (error) {
      console.warn(error);
      this.toastr.error('Failed to create Document.', 'Error');
      return null;
    }
  }

  get companySubtypeOptions(): SelectOption[] {
    return this.form.value.companyType ? companySubtypeDictionaryOptions[this.form.value.companyType] : [];
  }
}
